import { ActionTree } from 'vuex';

import { RootState } from '@/store/types';

import { subscribableStore } from './common';
import { ActivityTypesState } from './types';

const actions: ActionTree<ActivityTypesState, RootState> = {
  ...subscribableStore.actions,
};

export default actions;
